import { LoadingOutlined } from '@ant-design/icons';
import {
  Button,
  Form,
  Input,
  Spin,
} from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import account from '../../../../apis/admin/accoutService';
import { USER_INFO } from '../../../../configs/auth';
import notificationHandler from '../../../atoms/Notification';
import './account.scss'


const ChangePassWord: React.FC = () => {
  const useName: any = JSON.parse(localStorage.getItem(USER_INFO) || "null")?.sub;
  const loadingIcon = (
    <LoadingOutlined style={{ fontSize: 70, position: "fixed" }} spin />
  );
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  const onFinish = (values: any) => {
    setLoading(true);
    let param = {
      ...values, 
      username: useName
    }
    account.changePassWord(param).then(() => {
      notificationHandler('success', 'Đổi mật khẩu thành công!')
      navigate('/admin/listAccount')
      setLoading(false);
    }).catch((err) => {
      notificationHandler('error', err.response.data.data.msg_content)
      setLoading(false);
    })

  }
  return (
    <div className="changepass_wrapper">
      <Spin indicator={loadingIcon} spinning={loading} />
      <Form
        form={form}
        layout={'vertical'}
        name="changepass"
        onFinish={onFinish}
      >
        <h1 className="ant-typography !text-[20px]">Đổi mật khẩu</h1>
        <Form.Item
          name="passwordOld"
          label="Nhập mật khẩu hiện tại"
          rules={[
            {
              required: true,
              message: 'Mật khẩu hiện tại không được để trống!',
            },
          ]}
        >
          <Input.Password placeholder="Nhập mật khẩu hiện tại" maxLength={50}/>
        </Form.Item>
        <Form.Item
          name="passwordNew"
          label="Nhập mật khẩu mới"
          rules={[
            {
              required: true,
              message: 'Mật khẩu mới không được để trống!',
            },
            {

              pattern: /(?=(.*[0-9]))(?=.*[\!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?])(?=.*[a-z])(?=(.*[a-z]))(?=(.*)).{8,}|(?=.*[A-Z])(?=.*[0-9])(?=.*[\!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?]).{8,}/,
              message: "Mật khẩu không đủ mạnh"

            }
          ]}
        >
          <Input.Password placeholder="Nhập mật khẩu mới" maxLength={50}/>
        </Form.Item>
        <Form.Item
          name="confirm_password"
          label="Xác nhận mật khẩu mới"
          dependencies={['passwordNew']}
          rules={[
            {
              required: true,
              message: 'Mật khẩu xác nhận không được để trống!',
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('passwordNew') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('Mật khẩu không trùng khớp!'));
              },
            }),
          ]}
        >
          <Input.Password placeholder="Nhập mật khẩu xác nhận" maxLength={50}/>
        </Form.Item>
        <Form.Item >
          <Button type="primary" htmlType="submit">
            Đổi mật khẩu
          </Button>
        </Form.Item>
      </Form>
    </div>

  );
};

export default ChangePassWord;